<!-- eslint-disable -->
<template>
  <div class="big-screen-container" :style="containerStyle">
    <div class="back-btn" @click="goBack">
      <svg class="back-icon" width="22" height="22" viewBox="0 0 22 22" style="vertical-align: middle;">
        <circle cx="11" cy="11" r="10" fill="none" stroke="#1B77FF" stroke-width="2" />
        <polyline points="12,7 8,11 12,15" fill="none" stroke="#1B77FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="back-text">返回上一页</span>
    </div>
    <div class="big-screen-header"></div>
    <div class="big-screen-content">
      <div style="display: flex; justify-content: space-between; width: 55%;margin-top: 160px;">
        <img class="hover-zoom" style="cursor: pointer;" src="../assets/images/Component_153.png" alt="功能材料" @click="goToTupu('2')" />
        <img class="hover-zoom" style="cursor: pointer;" src="../assets/images/Component_154.png" alt="临港装备" @click="goToTupu('4')" />
      </div>
      <div style="display: flex; justify-content: space-between; width: 78%;margin-top: 0px">
        <img class="hover-zoom" style="cursor: pointer;" src="../assets/images/Component_152.png" alt="纺织服装" @click="goToTupu('1')" />
        <img class="hover-zoom" style="cursor: pointer;" src="../assets/images/Component_151.png" alt="汽模配" @click="goToTupu('3')" />

      </div>
        <img class="hover-zoom" style="cursor: pointer;" src="../assets/images/Component_155.png" alt="清洁能源" @click="goToTupu('5')" />
    </div>
    <div class="big-screen-footer">
      <div style="cursor:pointer;flex: 1; font-size:16px;display: flex; align-items: center; justify-content: center;line-height: 70px;color: white">
        备案信息：<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: white;">浙ICP备2025200610号-1</a>
      </div>
    </div>
  </div>
</template>

<script>
import { talentApi } from '../api/talent'
import autofit from 'autofit.js'
export default {
  name: 'IndustryTalentMap',
  data() {
    return {
      containerStyle: {
        backgroundImage: `url(${require('@/assets/images/Mask_group.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      },
      subIndexList:[]
    }
  },
  mounted() {
    autofit.init({
      fast: true,
      width: 1920,
      height: 1080,
      renderDom:'#app',
    },true)
    this.getSubIndexList()
  },
  methods: {
    getSubIndexList() {
      talentApi.subIndexListByParentId(this.$route.query.id).then(res => {
        this.subIndexList=res;
        console.log(res)
      })
    },
    goToTupu(name) {
      this.$router.push({ path: '/xiangshan-school-map', query: { id: name } })
    },
    // goToCleanEnergyTalentMap() {
    //   this.$router.push({ path: '/clean-energy-talent-map' })
    // },
    goBack() {
      this.$router ? this.$router.back() : window.history.back();
    },
  }
}
</script>

<style scoped>
.big-screen-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #0f1624;
  color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.back-btn {
  position: absolute;
  top: 80px;
  left: 70px;
  display: flex;
  align-items: center;
  color: #1B77FF;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  z-index: 20;
  user-select: none;
  transition: color 0.2s;
}
.back-btn:hover {
  color: #409eff;
}
.back-icon {
  margin-right: 6px;
  display: inline-block;
}
.back-text {
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 16px;
  font-weight: 250;
  line-height: normal;
  letter-spacing: 0em;
  color: #1B77FF;
}



.big-screen-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.big-screen-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-image: url('../assets/images/Group_42690.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70px;
}
.big-screen-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-image: url('../assets/images/big-screen-footer.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70px;
}

.page-title {
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  margin-bottom: 40px;
  margin-top: 20px;
}


.content-container {
  width: 100%;
  max-width: 1200px;
  height: calc(100% - 200px);
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 20px;
}

.hover-zoom {
  transition: transform 0.3s ease; /* 平滑过渡效果 */
}

.hover-zoom:hover {
  transform: scale(1.1); /* 鼠标悬停时放大 10% */
}
</style>
